import React from 'react';
import { createRoot } from 'react-dom/client';
import { 
  Modal, 
  ModalOverlay, 
  ModalContent, 
  ModalHeader, 
  ModalFooter, 
  ModalBody, 
  ModalCloseButton, 
  Button, 
  ChakraProvider 
} from '@chakra-ui/react';

class Dialog extends React.Component {
  render() {
    const { isOpen, onClose, onAccept, onDeny, acceptText, denyText, body, header, isClosable } = this.props;

    return (
      <Modal isOpen={isOpen} onClose={isClosable ? onClose : undefined} closeOnOverlayClick={isClosable} closeOnEsc={isClosable}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{header}</ModalHeader>
          {isClosable && <ModalCloseButton onClick={onDeny} />}
          <ModalBody>{body}</ModalBody>
          <ModalFooter>
            {acceptText && <Button colorScheme="blue" mr={3} onClick={onAccept}>
              {acceptText}
            </Button>}
            {denyText && <Button variant="ghost" onClick={onDeny}>
              {denyText}
              </Button>}
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  }
}

class DialogManager {
  constructor() {
    this.dialogContainer = document.createElement('div');
    document.body.appendChild(this.dialogContainer);
    this.root = null; // Add a property for the root
  }

  open({ onAccept = ()=>true, onDeny=()=>true, acceptText, denyText, body, header, isClosable = true }) {
    const onClose = () => {
      if (this.root) {
        this.root.unmount();
      }
    };

    this.root = createRoot(this.dialogContainer); // Create a root
    this.root.render(
      <ChakraProvider>
        <Dialog 
          isOpen={true} 
          onClose={onClose}
          onAccept={() => { onAccept(); onClose(); }} 
          onDeny={() => { onDeny(); onClose(); }}
          acceptText={acceptText}
          denyText={denyText}
          body={body}
          header={header} 
          isClosable={isClosable}
        />
      </ChakraProvider>
    );
  }
  
  close(){
    if (this.root) {
      this.root.unmount();
    }
  }
}

const dialogManager = new DialogManager();
export default dialogManager;